var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.minWidth)},[_c('Table',{ref:"_dynTable",attrs:{"scheme":_vm.s,"data":_vm.d,"resizable":"","noDataTemplate":_vm.noDataTemplate,"checkType":"none","fixHeader":_vm.fixHeight,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }